import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Input,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  BsBlockquoteRight,
  BsClipboard2Check,
  BsPencil,
  BsPersonFillAdd,
  BsPhone,
  BsWhatsapp,
} from "react-icons/bs";
import InvitationBg from "../../../../assets/InvitationBg.png";
import { IoColorPaletteOutline } from "react-icons/io5";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import {
  BASE_URL_EVENT,
  BASE_URL_MEDIA,
  BASE_URL_USER,
} from "../../../../Redux/App/action";

const ShareCardsPage = () => {
  const params = useParams();
  const id = params._id;
  localStorage.setItem("greetcardid", id);
  const [user, setUser] = useState(localStorage.getItem("user"));
  const [profileName, setProfileName] = useState("");
  const accessToken = localStorage.getItem("token");
  const [customCard, setCustomCards] = useState([]);
  const [customize, setCustomize] = useState(false);
  const [shareMultiple, setshareMultiple] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [from, setFrom] = useState("");
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [res, setRes] = useState([]);
  const navigate = useNavigate();
  const toast = useToast();
  const [customizable, setCustomizable] = useState(false);
  const [contacts, setContacts] = useState([
    { fullName: "", contactNumber: "", email: "" },
  ]);
  const search = useLocation().search;
  const id2 = new URLSearchParams(search).get("flag");
  const [login, setLogin] = useState(localStorage.getItem("user"));

  console.clear(`dimensions`, dimensions);
  const onImageLoad = ({ target: img }) => {
    setDimensions({
      width: img.offsetWidth,
      height: img.offsetHeight,
    });
  };
  useEffect(() => {
    console.log("this is useEffect no.. 2");

    const userData = localStorage.getItem("user");
    setUser(userData);
  }, []);

  const handleAddContact = () => {
    setContacts([...contacts, { fullName: "", contactNumber: "", email: "" }]);
  };

  const handleDeleteContact = (index) => {
    const updatedContacts = [...contacts];
    updatedContacts.splice(index, 1);
    setContacts(updatedContacts);
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedContacts = [...contacts];
    updatedContacts[index][name] = value;
    setContacts(updatedContacts);
  };

  const boxRef = useRef(null);
  const [boxHeight, setBoxHeight] = useState(null);
  const getCustomData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/canvas/get/canvastemplate?sourceMediaId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setCustomCards(response.data);
        if (response.data && response.data.length > 0) {
          const isCustomizable = response.data[0].customizable; // Assuming 'customizable' is a field in the first object of the response array
          setCustomizable(isCustomizable);
        }
      }
    } catch (error) {
      console.clear(error);
    }
  }, [id]);

  const getProfileData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setProfileData(response.data.payload);
        setProfileName(response.data.payload.fullName);
      }
    } catch (error) {
      console.clear(error);
    }
  }, [accessToken]);

  const handleCustomize = () => {
    const isloggedin = localStorage.getItem("user");
    if (isloggedin === null) {
      navigate("/authenticate", {
        state: { greet: `/shareCards/${id}` },
      });
      toast({
        title: "Please Login First",
        status: "success",
        duration: 5000,
        position: "top",
        isClosable: true,
      });
    } else if (customizable) {
      navigate(`/canvas/${id}`);
    } else {
      onOpen();
    }
  };

  const handleShare = () => {
    const formData = new FormData();
    formData.append("sharingModeType", "EMAIL");
    formData.append("canvasWidth", dimensions.width);
    formData.append("canvasHeight", dimensions.height);
    formData.append("sourceMediaId", id);
    formData.append("imageUrl", customCard[0].imageUrl);
    formData.append("fromText", from);
    contacts.forEach((contact, index) => {
      formData.append(`toText[${index}][guestName]`, contact.fullName);
      formData.append(
        `toText[${index}][guestPhoneNumber]`,
        contact.contactNumber
      );
      formData.append(`toText[${index}][guestEmail]`, contact.email);
    });

    console.clear(`formData`, formData);
    axios
      .post(`${BASE_URL_EVENT}/greetings/send`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        // Handle the response
        console.clear("response data", response.data);
        toast({
          title: "Hurray! Greeting debug Shared Via Mail.",
          status: "success",
          duration: 5000,
          position: "top",
          isClosable: true,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  //
  const handleWhatsappShareNow = () => {
    const formData = new FormData();
    formData.append("sharingModeType", "SELF_SHARE");
    formData.append("canvasWidth", 355);
    formData.append("canvasHeight", 490);
    formData.append("imageUrl", customCard[0].imageUrl);
    formData.append("fromText", profileData.fullName);
    if (formData.get("toText") === "") {
      formData.set("toText", null);
    }

    console.clear(`formData`, formData);
    axios
      .post(`${BASE_URL_EVENT}/greetings/send`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRes(response.data.payload);
        const data = response.data.payload[0].url;
        const whatsappUrl = `https://wa.me/send?text=${data}`;
        window.open(whatsappUrl);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleShareButtonClick = () => {
    if (!user) {
      toast({
        title: "Please Login",
        description: "Login First If You want to Share Card.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      handleWhatsappShareNow();
    }
  };

  const handleWhatsAppShare = () => {
    const formData = new FormData();
    formData.append("sharingModeType", "SELF_SHARE");
    formData.append("canvasWidth", 355);
    formData.append("canvasHeight", 490);
    formData.append("imageUrl", customCard[0].imageUrl);
    formData.append("fromText", profileData.fullName);

    if (formData.get("toText") === "null") {
      formData.set("toText", null);
    }

    console.clear(`formData`, formData);
    axios
      .post(`${BASE_URL_EVENT}/greetings/send`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        // Handle the response
        console.clear("response data", response.data);
        setRes(response.data.payload);
        const data = response.data.sharingUrl;
        const whatsappUrl = `https://wa.me/send?text=${data}`;
        window.open(whatsappUrl);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight;
      setBoxHeight(height);
    }
  }, []);

  useEffect(() => {
    if (login) {
      getProfileData();
    }
  }, [getProfileData, login]);

  useEffect(() => {
    getCustomData();
  }, [getCustomData]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box h={{ md: "100%", base: "auto" }} p={1}>
      <Box>
        <Text
          fontSize={{ base: "18px", md: "28px" }}
          textAlign={{ base: "center", md: "left" }}
          ml={"10"}
          className="oswald-font"
        >
          SEND CARDS
        </Text>
      </Box>
      <Flex
        w={"95%"}
        m={"auto"}
        flexDirection={{ md: "row", base: "column" }}
        h={"full"}
      >
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Share Greeting Card Via:</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box w={{ md: "100%", base: "100%" }} margin={"auto"}>
                <Flex
                  className="lato-font"
                  justifyContent={"center"}
                  w={{ md: "100%", base: "100%" }}
                  mt={{ base: 10, md: 50 }}
                >
                  <Tooltip
                    label={
                      "Sharing via Whatsapp Web, before clicking SEND wait for sometime to load the preview"
                    }
                    placement="top"
                    bgColor={"gray"}
                    className="lato-font"
                    fontSize={"xs"}
                    hasArrow
                  >
                    <Button
                      margin={"center"}
                      onClick={handleWhatsAppShare}
                      colorScheme="whatsapp"
                      w={{ md: "100%", base: "100%" }}
                      fontSize={{ base: "12px", md: "11px" }}
                    >
                      <Flex p={"5"} alignItems={"center"} gap={2}>
                        <BsWhatsapp size={18} />
                        Share on Whatsapp
                      </Flex>
                    </Button>
                  </Tooltip>
                </Flex>
                <Flex
                  mt={2}
                  mb={2}
                  gap={2}
                  justifyContent={"center"}
                  w={{ md: "100%", base: "100%" }}
                  alignItems={"center"}
                >
                  <Divider
                    margin={"auto"}
                    border={"1px solid black"}
                    w={{ md: "50%", base: "100%" }}
                  />
                  <Text className="lato-font">OR</Text>
                  <Divider
                    border={"1px solid black"}
                    w={{ md: "50%", base: "100%" }}
                  />
                </Flex>
                <Flex w={{ md: "100%", base: "100%" }} className="lato-font">
                  <Button
                    bg={"#AFAFAF"}
                    margin={"auto"}
                    w={{ md: "100%", base: "100%" }}
                    color={"black"}
                    mb={"10"}
                    fontSize={{ base: "12px", md: "11px" }}
                    onClick={() => setshareMultiple(!shareMultiple)}
                  >
                    <Flex alignItems={"center"} gap={2}>
                      <AiOutlineMail size={22} />
                      Share Multiple by Email
                    </Flex>
                  </Button>
                </Flex>
                <Box h={"100%"}>
                  {shareMultiple ? (
                    <Box
                      h={"50vh"}
                      overflowY={"auto"}
                      borderRadius={5}
                      p={1}
                      width={"100%"}
                    >
                      <Box mt={1} margin={"auto"} w={"100%"} overflowY={"auto"}>
                        {contacts.map((contact, index) => (
                          <Flex
                            key={index}
                            gap={2}
                            mt={2}
                            flexDir={"column"}
                            w={"100%"}
                          >
                            <Input
                              type="text"
                              name="fullName"
                              placeholder="Guest Name"
                              value={contact.fullName}
                              fontWeight={"semibold"}
                              border={0}
                              borderRadius={0}
                              textAlign={"left"}
                              borderBottom={"2px solid gray"}
                              _placeholder={{
                                textAlign: "left",
                                position: "absolute",
                                bottom: "-1px",
                                left: "0",
                                color: "gray.400",
                              }}
                              fontSize={14}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              onKeyDown={(event) => {
                                const sanitizedValue = /[0-9]/;
                                if (sanitizedValue.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            <Input
                              type="number"
                              name="contactNumber"
                              placeholder="Contact Number"
                              value={contact.contactNumber}
                              fontWeight={"semibold"}
                              border={0}
                              borderRadius={0}
                              textAlign={"left"}
                              borderBottom={"2px solid gray"}
                              _placeholder={{
                                textAlign: "left",
                                position: "absolute",
                                bottom: "-1px",
                                left: "0",
                                color: "gray.400",
                              }}
                              fontSize={14}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                            />
                            <Input
                              type="email"
                              name="email"
                              placeholder="Email"
                              value={contact.email}
                              fontWeight={"semibold"}
                              border={0}
                              borderRadius={0}
                              textAlign={"left"}
                              borderBottom={"2px solid gray"}
                              _placeholder={{
                                textAlign: "left",
                                position: "absolute",
                                bottom: "-1px",
                                left: "0",
                                color: "gray.400",
                              }}
                              fontSize={14}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                            />
                            <Flex
                              flexDir={"row"}
                              justifyContent={"space-between"}
                            >
                              <Button
                                colorScheme="red"
                                h={6}
                                fontSize={{ base: "10px", md: "11px" }}
                                w={"20%"}
                                size={"xs"}
                                onClick={() => handleDeleteContact(index)}
                              >
                                Delete
                              </Button>
                              <Button
                                colorScheme="blue"
                                h={8}
                                onClick={handleAddContact}
                              >
                                <BsPersonFillAdd size={18} />
                              </Button>
                            </Flex>
                          </Flex>
                        ))}
                      </Box>
                      <Flex justifyContent={"end"} mt={2}></Flex>
                      <Button
                        colorScheme="whatsapp"
                        fontWeight={"bold"}
                        onClick={() => {
                          handleShare();
                          setCustomize(false);
                        }}
                        mt={{ md: 4, base: 0 }}
                        w={{ md: "45%", base: "30%" }}
                        size={{ base: "xs", md: "sm" }}
                        margin={"auto"}
                      >
                        Share
                      </Button>
                    </Box>
                  ) : null}
                </Box>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>

        <Flex
          w={{ md: customize ? "50%" : "100%", base: "100%" }}
          borderLeftRadius={40}
          flexDirection={{ md: customize ? "column" : "row", base: "column" }}
          justifyContent={"center"}
          gap={{ md: customize ? 0 : 10, base: 0 }}
          mb={10}
        >
          <Flex
            gap={5}
            w={{ md: customize ? "100%" : "50%", base: "100%" }}
            justifyContent={"center"}
            flexDirection={customize ? "row" : "row"}
          >
            <Box w={"90%"}>
              <>
                <Box
                  className="lato-font"
                  mt={5}
                  display={customize ? "none" : "block"}
                  textAlign={"left"}
                >
                  <Flex
                    mb={"5"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Button
                      colorScheme="blue"
                      fontWeight={"bold"}
                      onClick={() => {
                        handleCustomize();
                      }}
                      w={{ md: "30%", base: "40%" }}
                      display={customize ? "none" : "block"}
                      ml={10}
                    >
                      Share Now
                    </Button>
                  </Flex>
                  <Text
                    fontSize={{ md: 14, base: 10 }}
                    fontWeight={"normal"}
                    m={"auto"}
                    w={{ md: "80%", base: "90%" }}
                  >
                    Wishfy offers an{" "}
                    <Text
                      as={"span"}
                      bgGradient="linear(to-r, red.400,pink.400)"
                      bgClip="text"
                    >
                      elegant Greetings card
                    </Text>{" "}
                    with text in cursive writing and colorful painted. This card
                    allows for a personalized message on the back. Perfect for
                    ecards, online Greeting cards, or emailed invitations.
                  </Text>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"left"}
                    mt={4}
                    alignItems={"center"}
                  >
                    <IoColorPaletteOutline size={30} />
                    <Text fontSize={{ md: 14, base: 10 }} fontWeight={"normal"}>
                      Change your Card’s text, style, envelope, stamp, backdrop,
                      and more. Add additional text boxes where you want them.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"left"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsPencil size={30} />
                    <Text fontSize={{ md: 14, base: 10 }} fontWeight={"normal"}>
                      Personalize with your event’s details, make or import a
                      guest list, and send with a click.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"left"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsBlockquoteRight size={30} />
                    <Text fontSize={{ md: 14, base: 10 }} fontWeight={"normal"}>
                      Use customizable Blocks for schedule, registry,
                      accommodations, travel details, and more.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"left"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsPhone size={30} />
                    <Text fontSize={{ md: 14, base: 10 }} fontWeight={"normal"}>
                      Send your way, via email, text message, or a shareable
                      link you can paste and post anywhere.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"left"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsClipboard2Check size={30} />
                    <Text fontSize={{ md: 14, base: 10 }} fontWeight={"normal"}>
                      Instantly track opens and RSVPs, communicate with
                      invitees, and use the app to check guests in on-site.
                    </Text>
                  </Flex>
                </Box>
              </>
            </Box>
          </Flex>

          <Box bgImage={InvitationBg} p={"5"} mr={"5"}>
            {customCard &&
              customCard.map((el, i) => (
                <>
                  {el.mediaType === "TEMPLATE_PREVIEW" ? (
                    <Image
                      src={el.imageUrl}
                      m={"auto"}
                      h={{ lg: 700, md: 500, base: 300 }}
                      key={i}
                      onLoad={onImageLoad}
                      mt={-1}
                      mb={2}
                    />
                  ) : null}
                </>
              ))}
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ShareCardsPage;
